import { mapState, mapGetters } from 'vuex';
import ApiService from '@/services/apiService';
import { randomPassword } from '@/utils/vuex';
export default {
  name: 'ViewAccountMgmtAccountMgmtUserBulkCreate',
  data: function () {
    return {
      tenantDetails: null,
      userDataCsv: '',
      faultyUserDataCsv: '',
      userCreateProgress: 0,
      scope: null,
      password: this.randomPassword,
      access: [],
      loading: false,
      valid: false,
      originalUser: null,
      defaultPasswordPolicy: {}
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'inpOutlined', 'inpFilled', 'color', 'UiTheme']),
    ...mapGetters({
      sessionUserId: 'authentication/userId'
    }),
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    },
    passwordRules() {
      return [v => !!v || this.$i18n_t('accMgmt.user.passwordErrors.USER_PASSWORD_REQUIRED'), v => v.length >= this.defaultPasswordPolicy.length || this.$i18n_tc('accMgmt.user.passwordErrors.USER_PASSWORD_MINLENGTH', this.defaultPasswordPolicy.length, {
        n: this.defaultPasswordPolicy.length
      })];
    },
    csvRules() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired'), v => {
        let emailAdresses = [];
        let userData = v.split(/\n/g);
        for (let i = 0; i < userData.length; i++) {
          const userDatum = userData[i].split(';');
          if (userDatum.length < 3) {
            if (userData[i].trim() !== '') {
              return this.$i18n_t('accMgmt.user.requiredCsvFields');
            }
          }
          if (userDatum.length >= 3) {
            if (emailAdresses.find(email => email.toLowerCase() === userDatum[2].toLowerCase())) {
              return this.$i18n_t('accMgmt.user.duplicateEmailsInCsv') + userDatum[2];
            }
            if (!/.+@.+\..+/.test(userDatum[2])) {
              return `${this.$i18n_t('Common.emailValid')} ${userDatum[2]}`;
            }
            emailAdresses.push(userDatum[2]);
            if (userDatum.length >= 4) {
              let userPropertyJson = null;
              try {
                // do not use the userDatum[3], in case the JSON contains any semicolons
                const replace = [userDatum[0], userDatum[1], userDatum[2], ''].join(';');
                const jsonString = userData[i].replace(replace, '');
                userPropertyJson = JSON.parse(jsonString);
              } catch (error) {
                // on error we return outside of try/catch
              }
              if (!userPropertyJson) {
                return this.$i18n_t('accMgmt.user.invalidCsvJson') + userDatum[3];
              }
            }
          }
        }
        return true;
      }];
    }
  },
  watch: {},
  mounted() {
    this.checkAccess();
    this.password = randomPassword();
  },
  methods: {
    cancelUserEdit() {
      this.$router.push({
        path: `/account-mgmt/${this.$route.params.tenantId}?userlist`
      });
    },
    checkAccess() {
      return this.fetchTenantData();
    },
    didSelectScope(scope) {
      this.scope = scope;
      this.fetchDefaultRoles(scope.id);
    },
    fetchDefaultRoles(scopeId) {
      ApiService.fetchDefaultRoles(scopeId).then(roles => {
        if (roles.length > 0) {
          this.access = [{
            tenantId: roles[0].tenantId,
            scopeId: scopeId,
            Scope: {
              id: scopeId
            },
            roles,
            primary: true
          }];
        }
      }).catch(() => {
        this.$snack(this.$i18n_t('accMgmt.user.createFailedSnack'), 'error');
      });
    },
    fetchTenantData() {
      return Promise.all([ApiService.tenantGetPasswordPolicy(),
      // NOTE: using `no-descendents` to not get any child-data; this will ALSO _NOT_ load any scope-descendents
      ApiService.tenantGetById(this.$route.params.tenantId, ['no-descendents'])]).then(data => {
        this.defaultPasswordPolicy = data[0];
        const tenant = data[1];
        this.tenantDetails = tenant;
        return tenant;
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack('Failed to fetch tenant', 'error');
        }
        this.$router.push({
          path: `/account-mgmt/${this.$route.params.tenantId}?userlist`
        });
      });
    },
    validate() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.snackbar = true;
      }
    },
    handleSubmit() {
      this.validate();
      if (this.valid) {
        this.parseCsv();
      }
    },
    async parseCsv() {
      let userData = this.userDataCsv.split(/\n/g);
      let userInfos = [];
      userData.forEach(data => {
        const userDatum = data.split(';');
        if (userDatum.length >= 3) {
          const userPropertyKeyValue = [];
          if (userDatum.length >= 4) {
            try {
              // do not use the userDatum[3], in case the JSON contains any semicolons
              const replace = [userDatum[0], userDatum[1], userDatum[2], ''].join(';');
              const jsonString = data.replace(replace, '');
              const userPropertyJson = JSON.parse(jsonString);
              if (userPropertyJson) {
                Object.keys(userPropertyJson).forEach(key => {
                  userPropertyKeyValue.push({
                    key: key,
                    value: userPropertyJson[key]
                  });
                });
              }
            } catch (error) {
              // ignore error
            }
          }
          const user = {
            firstName: userDatum[0],
            lastName: userDatum[1],
            email: userDatum[2],
            username: userDatum[2],
            active: true,
            properties: {
              values: userPropertyKeyValue
            },
            access: this.access,
            scope: this.scope,
            password: this.password
          };
          userInfos.push(user);
        }
      });
      this.userCreateProgress = 1;
      let faultyUsers = [];
      for (let i = 0; i < userInfos.length; i++) {
        const result = await this.createUser(userInfos[i]);
        if (result) {
          faultyUsers.push(userData[i]);
        } else {
          this.userCreateProgress = parseFloat(i + 1) / parseFloat(userInfos.length) * 100;
          this.$snack(this.$i18n_t('accMgmt.user.bulkCreateUserSuccessSnack', {
            i: i + 1,
            count: userInfos.length
          }), 'success');
        }
      }
      this.faultyUserDataCsv = faultyUsers.join('\n');
      if (faultyUsers.length === 0) {
        this.$router.push({
          path: `/account-mgmt/${this.$route.params.tenantId}?userlist`
        });
      }
    },
    createUser(user) {
      return ApiService.createUser(this.$route.params.tenantId, user).then(() => {
        return null;
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('accMgmt.user.createFailedSnack'), 'error');
        }
        return error;
      });
    },
    updatedUserAccess(access) {
      this.access = access;
      if ((access || []).length === 0) {
        this.scope = null;
      }
    }
  }
};